import { render, staticRenderFns } from "./CertificationChangeNotesList.vue?vue&type=template&id=ec81e3b8&scoped=true"
import script from "./CertificationChangeNotesList.vue?vue&type=script&lang=js"
export * from "./CertificationChangeNotesList.vue?vue&type=script&lang=js"
import style0 from "./CertificationChangeNotesList.vue?vue&type=style&index=0&id=ec81e3b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec81e3b8",
  null
  
)

export default component.exports